// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-simple-screen',
    computed: {
        hasImage() {
            return !utils.isNullOrEmpty(host.config.loginPageImage) && (host.pageMeta.options?.showImage ?? true);
        },
        getImageStyles() {
            return {
                'background-image': `url(${host.config.loginPageImage?.replace('./', '/')})`
            };
        },
        footerMenuEntriesRight() {
            return this.$host.store.getter("navigation/getMenu", "FOOTER").filter(e => e.alignment == 1);
        },
    }
});
// #endregion
